module.exports = __webpack_public_path__ + "../resources/img/ic_linked_default.70c8918d.svg";